export default __webpack_public_path__ + "static/media/neon_treat@3x.3926e36a.png";